import { InjectionToken } from '@angular/core';

export const DELON_LOCALE = new InjectionToken<string>('delon-locale');
